const taskDomainErrors = {
  18 : {domain: ["twitter.com", 'x.com'], message:"Please enter a valid Twitter URL."},
  19 : {domain: ["facebook.com"        ], message:"Please enter a valid Facebook URL."},
  20 : {domain: ["tiktok.com"          ], message:"Please enter a valid TikTok URL."},
}

const checkDomainInList = (domainList, input) => {
   return domainList.reduce((acc, currentValue) =>  acc |= input.includes(currentValue), false);
}

export default {
  required: {
    message : "Input is required!",
    fn      : (input)=> {
      return input?.length},
  },

  url: {
    message : "URL is not valid!",
    fn      : (input, task)=> {
      let regEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
      return task.type == 1 ? regEx.test(input): true;
    }
  },

  expectedFacebook: {
    message : (task)=> {return taskDomainErrors[task.id].message},
    fn      : (input, task)=> {
      return (task.type == 1 && Object.keys(taskDomainErrors).includes(String(task.id))) ? checkDomainInList(taskDomainErrors[task.id].domain, input) : true;
    }
  }
}
